import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class KeyDetailPageService {
  searchResultCount = new BehaviorSubject<Record<string, number>>({});
}
